import { noteConstant } from '../constants';
import { noteService } from '../../services';
import { history } from '../../helpers';

export const notesAction = {
	getNotes,
	showNote,
	viewNote,
	deleteNote,
};

function getNotes() {
	return (dispatch) => {
		const promise = new Promise((resolve, reject) => {
			dispatch(request(true));
			noteService.getNotes().then((res) => {
				resolve(res);
				dispatch(success(res));
			});
		});
		return promise;
	};
	function request(res) {
		return { type: noteConstant.NOTE_LIST_REQUEST, res };
	}
	function success(res) {
		return {
			type: noteConstant.NOTE_LIST_SUCCESS,
			res,
		};
	}
	function failure(error) {
		return { type: noteConstant.NOTE_LIST_FAILURE, error };
	}
}

function viewNote(note_id) {
	return (dispatch) => {
		const promise = new Promise((resolve, reject) => {
			dispatch(request(true));
			noteService.viewNote(note_id).then((res) => {
				resolve(res);
				dispatch(success(res));
			});
			(error) => {
				dispatch(failure(error.toString()));
			};
		});
		return promise;
	};
	function request(res) {
		return { type: noteConstant.NOTE_LIST_REQUEST, res };
	}
	function success(data) {
		return {
			type: noteConstant.NOTE_LIST_SHOW,
			data,
		};
	}
	function failure(error) {
		return { type: noteConstant.NOTE_LIST_FAILURE, error };
	}
}

function showNote(data) {
	return { type: noteConstant.NOTE_LIST_SHOW, data };
}

function deleteNote(note_id) {
	return (dispatch) => {
		const promise = new Promise((resolve, reject) => {
			noteService.deleteNote(note_id).then((res) => {
				resolve(res);
				dispatch(success(res));
			});
		});
		return promise;
	};
	function request() {
		return { type: noteConstant.NOTE_LIST_REQUEST };
	}
	function success(data) {
		return {
			type: noteConstant.NOTES_DELETE_SUCCESS,
			data,
		};
	}
	function failure(error) {
		return { type: noteConstant.NOTE_LIST_FAILURE, error };
	}
}

function showNote(data) {
	return { type: noteConstant.NOTE_LIST_SHOW, data };
}



// WEBPACK FOOTER //
// ./src/store/actions/note.actions.js